import styled from 'styled-components';

type ShareBoxLayout = 'popover' | 'inline';

export const Container = styled.div<{ $shareBoxLayout?: ShareBoxLayout }>`
  .close.bidding-share-close {
    margin: 0;
    color: #9e9e9e;
    opacity: 1;
    text-shadow: none;
    padding: 0.35rem 0.25rem;
    font-size: 1.5rem;
    line-height: 1;
    font-weight: 300;

    &:hover,
    &:focus {
      color: #757575;
      opacity: 1;
    }
  }

  .bidding-share {
    border: solid 1px ${(props) => props.theme.$gray400};
    border-radius: 4px;
    background: white;

    ${(props) =>
      (props.$shareBoxLayout ?? 'popover') === 'inline'
        ? `
      position: relative;
      width: 100%;
      max-width: 22rem;
      padding: 8px 12px 28px 12px;
      z-index: 1;
    `
        : `
      position: absolute;
      z-index: 15;
      padding: 0px 15px 35px 15px;
      right: 15px;
      top: 65px;

      @media only screen and (max-width: 768px) {
        top: 117px;
      }
    `}
  }

  .progress {
    position: absolute;
    bottom: 0;
    border-radius: 0 0 0.2rem 0.2rem;
  }
`;
